import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { User } from 'src/app/component/auth/model/user.model';
import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { SimpleDatePipe } from 'src/app/pipes/simple-date.pipe';
import { LoginTokenService } from 'src/app/service/login-token.service';
import { SchoolEnrollment } from '../../../model/school-enrollment.model';
import { StudentTerminationStatusType } from '../../../model/student-termination-status-type.model';
import { StudentTerminationStatus } from '../../../model/student-termination-status.model';
import { StudentTerminationsService } from '../../../service/student-terminations.service';
import { StudentHelperService } from '../../../service/student-helper.service';
import { StudentHelper2Service } from '../../../service/student-helper2.service';

@Component({
    selector: 'view-child-demographic-termination',
    templateUrl: './view-child-demographic-termination.component.html',
    styleUrl: './view-child-demographic-termination.component.scss'
})
export class ViewChildDemographicTerminationComponent implements OnInit {
    @Input() studentId!: number;
    @Input() studentHelperNumber: number = 1;

    studentTerminationStatusesBackup: StudentTerminationStatus[] = [];
    studentTerminationStatuses: StudentTerminationStatus[] = [];
    studentTerminationStatusesToCreate: StudentTerminationStatus[] = [];
    studentTerminationStatusesToDelete: StudentTerminationStatus[] = [];

    studentTerminationStatusTypes: StudentTerminationStatusType[] = [];
    schoolEnrollments: SchoolEnrollment[] = [];
    studentTerminationStatusFound: boolean = false;
    schoolEnrollmentRequired: boolean = false;

    currentUser: User;

    isLoading: boolean = false;
    isSaving: boolean = false;
    adding: boolean = false;

    promises: Array<any> = [];

    // Table display
    displayedColumns: string[] = ['STATUS_DATE', 'STUDENT_TERMINATION_STATUS_TYPES.TYPE', 'CREATED_BY', 'CREATED_DATE'];

    // Table results
    tableDataSource: MatTableDataSource<StudentTerminationStatus>;

    // Changes
    formChanges: any = {};

    getPropertyPipe = new GetPropertyPipe();

    subs: Subscription[] = [];

    constructor(
        private studentTerminationsService: StudentTerminationsService,
        private loginTokenService: LoginTokenService,
        private cleanDatePipe: CleanDatePipe,
        private simpleDatePipe: SimpleDatePipe,
        private studentHelperService: StudentHelperService,
        private studentHelper2Service: StudentHelper2Service
    ) {}

    ngOnInit(): void {
        this.init();
    }

    init() {
        this.isLoading = true;
        this.studentTerminationStatusesToCreate = [];
        this.studentTerminationStatusesToDelete = [];

        this.getStudentTerminationStatuses();
        this.getStudentTerminationStatusTypes();
        this.getSchoolEnrollments();
        this.getCurrentUser();
        Promise.all(this.promises).then((res) => {
            this.updateDataSource();

            // Set Termination Reversed to unselectable if no termination exists
            let index = this.studentTerminationStatusTypes.findIndex((stst) => stst.TYPE === 'Termination Reversed');

            if (index >= 0) {
                this.studentTerminationStatusTypes[index].SELECTABLE =
                    this.studentTerminationStatuses.length > 0 && this.studentTerminationStatuses[0].STUDENT_TERMINATION_STATUS_TYPES.ID !== 1 ? 1 : 0;
            }

            if (
                this.studentTerminationStatuses &&
                this.studentTerminationStatuses.length > 0 &&
                this.studentTerminationStatuses[0].STUDENT_TERMINATION_STATUS_TYPES.ID !== 1
            ) {
                if (this.studentHelperNumber === 1) {
                    this.studentHelperService.setTerminated('Terminated');
                } else {
                    this.studentHelper2Service.setTerminated('Terminated');
                }
            } else {
                this.studentHelperService.setTerminated('');
                this.studentHelper2Service.setTerminated('');
            }

            this.isLoading = false;
        });
    }

    getStudentTerminationStatuses() {
        let deferred = new Promise((resolve, reject) => {
            this.studentTerminationsService.getStudentTerminationStatusHistory(this.studentId).subscribe((res: any) => {
                if (res.studentTerminationStatuses) {
                    this.studentTerminationStatuses = res.studentTerminationStatuses;

                    this.studentTerminationStatuses.forEach((sts) => {
                        sts.STATUS_DATE = this.cleanDatePipe.transform(sts.STATUS_DATE);
                        sts.CREATED_DATE = this.cleanDatePipe.transform(sts.CREATED_DATE);
                    });

                    this.studentTerminationStatuses.sort((n1, n2) => {
                        const createdDiff = new Date(n2.CREATED_DATE).getTime() - new Date(n1.CREATED_DATE).getTime();

                        if (createdDiff !== 0) {
                            return createdDiff;
                        }

                        return new Date(n2.STATUS_DATE).getTime() - new Date(n1.STATUS_DATE).getTime();
                    });

                    this.studentTerminationStatusesBackup = JSON.parse(JSON.stringify(this.studentTerminationStatuses));

                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getStudentTerminationStatusTypes() {
        let deferred = new Promise((resolve, reject) => {
            this.studentTerminationsService.getStudentTerminationStatusTypes().subscribe((res: any) => {
                if (res.studentTerminationStatusTypes) {
                    this.studentTerminationStatusTypes = res.studentTerminationStatusTypes;

                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getSchoolEnrollments() {
        let deferred = new Promise((resolve, reject) => {
            this.studentTerminationsService.getSchoolEnrollments(this.studentId).subscribe((res: any) => {
                if (res.schoolEnrollments) {
                    this.schoolEnrollments = res.schoolEnrollments;

                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getCurrentUser() {
        this.currentUser = this.loginTokenService.getUser();
    }

    updateDataSource() {
        setTimeout(() => {
            // Data
            let dataSource = new MatTableDataSource<StudentTerminationStatus>();
            dataSource.data = this.studentTerminationStatuses;

            this.tableDataSource = dataSource;
        });
    }
}
